<template>
  <div>
    <ScaleLoader 
      :loading="loading" 
      :color="color" 
      :customclass="customclass"
      style="min-width:50px;"
    />
  </div>
</template>


<script>
//change default loader here
import ScaleLoader  from './ScaleLoader.js'

export default {
  props:["loading", "size", "color", "width", "height", "radius", "margin", "customclass"],
  components: {
    ScaleLoader, //change default loader here
  }
}
</script>
